import { EsAuthor } from './EsAuthor';
import { SearchPath } from './search-path';
import { CdxTask } from './cdx-task';

export enum ActivityType {
  Create = 'CREATE',
  Update = 'UPDATE',
  UpdateStatus = 'UPDATE_STATUS',
  AddComment = 'ADD_COMMENT',
  UpdateComment = 'UPDATE_COMMENT',
  DeleteComment = 'DELETE_COMMENT',
  AddCommentReply = 'ADD_COMMENT_REPLY',
  UpdateCommentReply = 'UPDATE_COMMENT_REPLY',
  DeleteCommentReply = 'DELETE_COMMENT_REPLY',
  AddAttachment = 'ADD_ATTACHMENT',
  UpdateAttachment = 'UPDATE_ATTACHMENT',
  DeleteAttachment = 'DELETE_ATTACHMENT',
  AttachTeams = 'ATTACH_TEAMS',
  ActivateAlert = "ALERT_ACTIVATE",
  DeactivateAlert = "ALERT_DEACTIVATE",

  PROCESS_STARTED = 'PROCESS_STARTED',
  PROCESS_COMPLETED = 'PROCESS_COMPLETED',
  PROCESS_CANCELLED = 'PROCESS_CANCELLED',

  TASK_ARCHIVE_UPSERTED = 'TASK_ARCHIVE_UPSERTED',
  TASK_ASSIGNED ='TASK_ASSIGNED',
  TASK_COMPLETED='TASK_COMPLETED',
  TASK_CREATED='TASK_CREATED',
  TASK_FORM_SAVED='TASK_FORM_SAVED',

  TASK_OBSERVER_UPDATE = 'UPDATE_OBSERVER',
}

export enum OnlyOn {
  DIFF = 'differing',
  NEW = 'onlyOnNew',
  OLD = 'onlyOnOld'
}

export class ActivityDifferingDatas {
  oldData: any;
  newData: any;
  searchPath?: SearchPath;
}

export class Diff {
  differing: {[key: string]: any} = {};
  onlyOnNew: {[key: string]: any} = {};
  onlyOnOld: {[key: string]: any} = {};
}

export class TopicSortedDiff {
  formedLinkData: NonNullable<unknown>;
  formedMetadata: any[];
  formedData: any[];
}

export class ActivityTopicSortedDiff {
  id: number;
  diff: TopicSortedDiff;
}

export class ActivityDiff {
  id: number;

  //fixme : incohérence par rapport au back , il faudra peut-être le retirer à un moment donné
  diff: Diff;

  differing?: {[key: string]: any} = {};
  onlyOnNew?: {[key: string]: any} = {};
  onlyOnOld?: {[key: string]: any} = {};
}

export class CdxActivity {
  id: number;
  auditData: object;
  auditDataTask?: CdxTask;
  eventType: ActivityType;
  created: string;
  objId: string;
  entityType: string;
  userId: string;
  diff: ActivityDiff;
  cdx_author: EsAuthor;
  externalId: string;
  version: string;
  createdDate?: Date;
  task_instance_id?:string;
  delegueId?:number;
  supervisorId?:number;
 }

 export class OpenCloseActivityItem {
  activity: CdxActivity;
  isOpened: boolean;
  constructor(activity: CdxActivity, isOpened: boolean) {
    this.activity = activity;
    this.isOpened = isOpened;
  }
 }
